export default "__VITE_ASSET__COGqdKjd__"